// import this after install `@mdi/font` package
import VueFroala from 'vue-froala-wysiwyg';
//Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/image_tui.min';
import 'froala-editor/js/third_party/spell_checker.min';
// Import Froala Editor css files.
import { useSnackbarStore } from '@/stores/snackbarInfo';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';

export default defineNuxtPlugin((app) => {
  app.vueApp.use(VueFroala);
});
